import { ModalUpgradeTypeEnum } from './CommonGatedUpgradeModal.types';

/**
 * Handles the translation of modal types to their corresponding text keys.
 * Based on the provided `modalType`, it returns a specific text key
 * that corresponds to a type of upgrade modal.
 *
 * @param {string} modalType - The type of modal, used to determine the appropriate text key.
 * @returns {string} The text key for the given modal type, or undefined if the type is not recognized.
 */
const handleTranslationText = (modalType: string) => {
  switch (modalType) {
    case ModalUpgradeTypeEnum.ImproveText:
      return 'improveTextUpgradeModal';
    case ModalUpgradeTypeEnum.MapCharts:
      return 'mapChartsUpgradeModal';
    case ModalUpgradeTypeEnum.IconUpgrade:
      return 'iconUpgradeModal';
    case ModalUpgradeTypeEnum.BrandKit:
      return 'brandKitUpgradeModal';
    case ModalUpgradeTypeEnum.Templates:
      return 'templateUpgradeModal';
    default:
      return;
  }
};

export { handleTranslationText };
